class CartRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.fetchAndRenderRecommendations();
    }

    fetchAndRenderRecommendations() {
        const maxProducts = parseInt(this.getAttribute('max-products')) || Infinity;

        this.getCartItems()
            .then(cartItems => this.fetchRecommendationsForCartItems(cartItems))
            .then(recommendationsArray => this.processRecommendations(recommendationsArray, maxProducts))
            .catch(error => {
                console.error("Error fetching or rendering recommendations:", error);
            });
    }

    getCartItems() {
        return new Promise((resolve, reject) => {
            const cartItems = document.querySelectorAll('.cart-item');
            if (cartItems.length > 0) {
                resolve(cartItems);
            } else {
                reject("No cart items found.");
            }
        });
    }

    fetchRecommendationsForCartItems(cartItems) {
        const fetchPromises = Array.from(cartItems).map(item => {
            const productId = item.dataset.productId;
            const recommendationsUrl = this.dataset.url.replace("productId", productId);
            return this.fetchRecommendations(recommendationsUrl);
        });
        return Promise.all(fetchPromises);
    }

    fetchRecommendations(url) {
        return fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector("cart-recommendations");
                return recommendations && recommendations.innerHTML.trim().length ? recommendations : null;
            })
            .catch(error => {
                console.error("Error fetching recommendations:", error);
                return null;
            });
    }

    processRecommendations(recommendationsArray, maxProducts) {
        const uniqueProductDetails = [];
        const uniqueProductNames = new Set();
        let productsCount = 0;
    
        recommendationsArray.forEach(recommendations => {
            if (!recommendations) return; // Skip if recommendations are null
            const productDivs = recommendations.querySelectorAll('.cart-pr');
            productDivs.forEach(div => {
                if (productsCount >= maxProducts) return;
                const productNameElement = div.querySelector('.cr-product-name');
                if (productNameElement) {
                    const productName = productNameElement.textContent.trim();
                    if (!uniqueProductNames.has(productName)) {
                        uniqueProductNames.add(productName);
                        uniqueProductDetails.push(div.outerHTML);
                        productsCount++;
                    }
                }
            });
        });
    
        if (productsCount > 0) {
            const headingElements = document.getElementsByClassName("cr_heading");
            for (const element of headingElements) {
                element.classList.add("!block");
            }
        }

        const allRecommendationsHTML = uniqueProductDetails.join("");
    
        this.insertAdjacentHTML('beforeend', allRecommendationsHTML);
    }    
}

customElements.define('cart-recommendations', CartRecommendations);